export const VIBRATION_ON_SCAN_SUCCESS_PATTERN = [100, 50, 100]; // in ms;
export const VIBRATION_ON_SCAN_ERROR_PATTERN = [400];
export const CAMERA_SCANNER_START_LOAD_DELAY = 500;
export const CAMERA_DELAY = 300;
export const CAMERA_RESOLUTION = 720;
